import { applyDecorators, Type } from '@nestjs/common';
import { ApiProperty, ApiPropertyOptional, ApiPropertyOptions } from '@nestjs/swagger';
import { Type as TypeTransform } from 'class-transformer';
import {
  ArrayMaxSize,
  ArrayNotEmpty,
  ArrayUnique,
  IsArray,
  IsDate,
  isDefined,
  IsInt,
  IsOptional,
  IsString,
} from 'class-validator';

import {
  ARRAY_EMPTY,
  ARRAY_INVALID_CONTENT_TYPE,
  ARRAY_INVALID_SIZE,
  ARRAY_MUST_BE_UNIQUE,
  FIELD_MUST_BE_AN_ARRAY,
} from '../constants';

class PropertyArrayParams {
  isOptional?: boolean;
  isNotEmpty?: boolean;
  isUnique?: boolean;
  type!: Type<unknown> | Function | [Function] | 'array' | 'string' | 'number' | 'boolean' | 'integer' | 'null';
  enumValue?: any[] | Record<string, any>;
  maxSize?: number;
  name?: string;
}

function checkType(type: typeof PropertyArrayParams.prototype.type) {
  if (type === 'number' || type === Number) {
    return [
      TypeTransform(() => Number),
      IsInt({ message: ARRAY_INVALID_CONTENT_TYPE, each: true, context: { expected: 'number' } }),
    ];
  }
  if (type === Date) {
    return [
      TypeTransform(() => Date),
      IsDate({ message: ARRAY_INVALID_CONTENT_TYPE, each: true, context: { expected: 'date' } }),
    ];
  }
  if (type === 'string' || type === String) {
    return [IsString({ message: ARRAY_INVALID_CONTENT_TYPE, each: true, context: { expected: 'string' } })];
  }
  return [TypeTransform(() => type as Function)]
}

export function ApiPropertyArray(
  { isOptional, isNotEmpty, isUnique, type, enumValue, maxSize, name }: PropertyArrayParams,
) {
  const propertyOptions: ApiPropertyOptions = {
    isArray: true,
    type,
    ...(enumValue && { enum: enumValue }),
    name,
  };

  return applyDecorators(
    ...isOptional
      ? [IsOptional(), ApiPropertyOptional(propertyOptions)]
      : [ApiProperty(propertyOptions)],
    IsArray({ message: FIELD_MUST_BE_AN_ARRAY }),
    ...checkType(type),
    ...isNotEmpty ? [ArrayNotEmpty({ message: ARRAY_EMPTY })] : [],
    ...isUnique ? [ArrayUnique({ message: ARRAY_MUST_BE_UNIQUE })] : [],
    ...isDefined(maxSize)
      ? [ArrayMaxSize(maxSize!, { message: ARRAY_INVALID_SIZE, context: { maxSize } })]
      : [],
  );
}
